import { render, staticRenderFns } from "./transferRegions.vue?vue&type=template&id=f0b84f08&scoped=true&"
import script from "./transferRegions.vue?vue&type=script&lang=ts&"
export * from "./transferRegions.vue?vue&type=script&lang=ts&"
import style1 from "./transferRegions.vue?vue&type=style&index=1&id=f0b84f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b84f08",
  null
  
)

export default component.exports